var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 22 22","width":"22","height":"22"}},[_c('path',{attrs:{"stroke":"#121212","stroke-linecap":"round","stroke-width":"1.6","d":"M11 18.857s6.286-3.143 6.286-7.857V5.5l-3.287-1L11 3.143 8 4.5l-3.286 1V11c0 4.714 6.286 7.857 6.286 7.857z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }